import colors from "@/theme/colors"
import styled from "@emotion/styled"
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite"
import { Button, Typography } from "@mui/material"
import dynamic from "next/dynamic"
import { useState } from "react"
import { offScreen } from "theme/shared"

const VideoDialog = dynamic(() => import("Components/VideoDialog"))

const Styled = {
  Headline: styled(Typography)`
    ${offScreen({ yPos: "calc(-50% - 50vh)" })}
    line-height: 1.4;
  `,
  BoldHeadline: styled.span`
    font-weight: bold;
    font-size: 25px;
    margin-top: 5px;
    display: block;

    ${(p) => p.theme.breakpoints.up("md")} {
      span {
        margin: 0 69.5px 0;
        font-size: 38px;
        font-weight: normal;
        display: block;
      }
      font-size: 70px;
    }
  `,

  Button: styled(Button)`
    margin-top: 20px;
    font-size: 16px;
    font-weight: 600;
    ${offScreen({ yPos: "calc(-50% - 50vh)" })}

    svg {
      font-size: 40px !important;
      fill: ${colors.hotPink};
    }
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 24px;
      border-radius: 31px;
      width: 275px;
      height: 62px;
      padding: 5px;
    }
  `,
}

interface HeroHomepageProps {
  section?: {
    title?: string
    titleSuffix?: string
    subtitle?: string
    buttonText?: string
    videoUrl?: string
  }
}

const HeroHomepage = ({ section }: HeroHomepageProps) => {
  const [openVideo, setOpenVideo] = useState(false)

  // Use database content with fallback to hardcoded values
  const title = section?.title || "We make products"
  const titleSuffix = section?.titleSuffix || "that grow your business"
  const subtitle = section?.subtitle || "<and users actually use>"
  const buttonText = section?.buttonText || "Play to know us"
  const videoUrl = section?.videoUrl || "/videos/mint-intro.mp4"

  return (
    <>
      <Styled.Headline variant="h1">
        <Styled.BoldHeadline>
          {title} <br /> {titleSuffix}
        </Styled.BoldHeadline>
        {subtitle}
      </Styled.Headline>
      <Styled.Button
        variant="outlined"
        startIcon={<PlayCircleFilledWhiteIcon />}
        onClick={() => setOpenVideo(true)}
      >
        {buttonText}
      </Styled.Button>
      {openVideo && (
        <VideoDialog open={openVideo} onClose={() => setOpenVideo(false)} />
      )}
    </>
  )
}

export default HeroHomepage
